export enum FilterOptionRequest {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
}
